export const deliveryClosingHourFn = (data) => {
      const currentTime = setSeconds(
        `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      );
    
      const openingHour = setSeconds(data?.delivery_opening_time);
      const closingHour = setSeconds(data?.delivery_closing_time);
      // console.log(openingHour, closingHour, "closing and opening")
      // console.log(currentTime, "currentTime")
      // console.log( `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`, "timeString")
      // console.log(parseInt(currentTime) > parseInt( openingHour), "isTrueorFalse")
    
      const orderTimeState =
        currentTime >= openingHour && currentTime < closingHour;
      return orderTimeState;
    };
    
    const setSeconds = (t) => {
      const timeArray = t?.split(":");
      if (timeArray?.length > 1) {
        return (
          parseInt(timeArray[0]) * 60 * 60 +
          parseInt(timeArray[1]) * 60 +
          parseInt(timeArray[2])
        );
      }
    };
    